import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { EmailConfirmedView } from '@/features/email-confirmation/EmailConfirmedView'

export default observer(function EmailConfirmedViewContainer() {
  const { authenticationVm, shellInfo } = useFeatures(({ iam, shell }) => ({
    authenticationVm: iam.authenticationViewModel,
    shellInfo: shell.shellInfo,
  }))

  return (
    <EmailConfirmedView
      onSignIn={() => authenticationVm.authorize('login')}
      logoPrimary={shellInfo.logoUrl}
      landingPageImage={shellInfo.landingPageImageUrl}
    />
  )
})
